export default __webpack_public_path__ + "static/media/profile-icon.e9bc3280.svg";